import { compressCoverImage } from "../../utils/imageCompression"

export const handleThumbnailChange = async (e, setFieldValue) => {
  const f = e.target.files[0]
  if (!f) return
  try {
    const compressed = await compressCoverImage(f)
    setFieldValue("thumbnailImg", compressed)
  } catch (err) {
    setFieldValue("thumbnailImg", f)
  }
}

